import {
    Container,
    Card,
    Text,
    VStack,
    HStack,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    FormControl,
    FormLabel,
    Radio,
    Stack,
    RadioGroup,
    Row,
} from "@chakra-ui/react";
import React, { useEffect, useState } from 'react'
import { useFormik } from "formik";
import { useLocation } from 'react-router-dom';
import { useMemberShip } from "../../providers/MemberShipProvider";
import moment from "moment";
import { toast } from "react-toastify";
import { useUsers } from "../../providers/UsersProvider";

export default function DeleteUser() {

    const { state } = useLocation();

    const { installments, getInstallments, acceptStorePayment } = useMemberShip();
    const { isOpen, onOpen, onClose } = useDisclosure()

    const [term, setTerm] = useState(-1);

    const formik = useFormik({
        initialValues: {
            payment_mode: "COD",
        },
        onSubmit: async (values) => {
            console.log(state);
            let submitFields = {
                id: state.id,
                term: term,
                payment_mode: values.payment_mode,
                date: moment().format("YYYY-MM-DD"),
            };
            onClose();
            console.log(submitFields);
            try {
                await acceptStorePayment(submitFields);
            } catch (error) {
                toast.error("Error Accepting Payment !");
            }

        }
    });


    const { deleteData } = useUsers();

    useEffect(() => {
        getInstallments(state.id);
    }, [state])

    return (
        <>
            <Container maxW='6xl' my='4'>
                <VStack>

                    <Card color='white' borderRadius='md' p='4' bg='red.600' width={'100%'}>
                        <VStack w='100%'>

                            <Text fontWeight='bold' className='customfont' fontSize='xl'>Delete Membership ??</Text>

                            <Text fontSize='md'>This action is irreversible !!</Text>

                            <Button colorScheme='orange' onClick={() => deleteData(state.id)}>
                                YES I UNDERSTAND . DELETE MEMBERSHIP
                            </Button>
                        </VStack>
                    </Card>

                    <Card borderRadius='md' p='4' width={'100%'}>
                        <VStack w='100%'>
                            <HStack w='100%' justifyContent='space-between'>

                                <Text fontWeight='bold' className='customfont' fontSize='2xl'>Membership Details</Text>

                            </HStack>

                            <VStack width='100%' spacing={4} alignItems='start'>
                                <Text>Name : {state.name}</Text>
                                <Text>Membership ID : {state.id_number}</Text>
                                <Text>Phone : {state.phone}</Text>
                                <Text>Address : {state.address}</Text>
                            </VStack>
                        </VStack>
                    </Card>


                    <Card width={'100%'}>

                        <table>
                            <thead>
                                <tr>
                                    <th py='4' fontSize='sm'>Term</th>
                                    <th py='4' fontSize='sm'>Amount</th>
                                    <th py='4' fontSize='sm'>User Paid</th>
                                    <th style={{ width: '160px' }} py='4' fontSize='sm'>Store Payment Status</th>
                                    <th style={{ width: '160px' }} py='4' fontSize='sm'>Payment Mode</th>
                                    <th style={{ width: '160px' }} py='4' fontSize='sm'>Payment Date</th>


                                </tr>
                            </thead>

                            <tbody>
                                {installments.map((i, idx) => {
                                    return (
                                        <tr key={idx}>
                                            <td py='4' fontSize='sm'>{i.term}</td>
                                            <td py='4' fontSize='sm'> {i.amount}</td>
                                            <td py='4' fontSize='sm'> {i.paid_by_user ? 'Yes' : 'No'}</td>
                                            <td py='4' fontSize='sm'> {i.accepted_by_store ? 'Yes' : 'No'}</td>
                                            <td py='4' fontSize='sm'> {i.payment_mode}</td>
                                            <td py='4' fontSize='sm'>
                                                {i.user_payment_date == null ? "" : moment(i.user_payment_date).format('DD-MM-YYYY')}
                                            </td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Card>

                </VStack>
            </Container>

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Accept Payment</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <form onSubmit={formik.handleSubmit}>
                            <VStack alignItems='start' spacing='6'>
                                <FormControl>
                                    <FormLabel>Payment Mode</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            formik.setFieldValue('payment_mode', e);
                                        }}
                                        value={formik.values.payment_mode}
                                    >
                                        <Stack direction='row'>
                                            <Radio _selected={formik.values.payment_mode == "COD"} value='COD'>COD</Radio>
                                            <Radio _selected={formik.values.payment_mode == "Online"} value='Online'>Online</Radio>
                                        </Stack>
                                    </RadioGroup>
                                </FormControl>
                                <HStack>
                                    <Button type="submit" colorScheme="whatsapp">Accept</Button>
                                    <Button onClick={onClose} colorScheme="red">Close</Button>
                                </HStack>
                            </VStack>
                        </form>
                    </ModalBody>
                </ModalContent>
            </Modal>

        </>
    )
}
